export default "__VITE_ASSET__Cr6FHYCm__"